export const sliceToLetters = function(elem) {
    if (elem) {
        elem.forEach((item, index) => {
            item.innerHTML = item.textContent.replace(/\S/g, "<span class='letter'>$&</span>")
        })
    }
}
